import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
sliders: drilldownData["sliders"].map(
  ({
    fieldName,
    placeholder,
    name,
    formType,
    validation,
    className,
    loadOptions,
    options,
    usedFileType,
    note
  }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    loadOptions,
    options,
    usedFileType,
    note
  })
),



  cards: drilldownData["cards"]?.map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, options, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),

    pages: drilldownData["pages"]?.map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, options, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),

  // If your drilldownData contains separate spotlight-card / spotlight-page / highlight,
  // you can add them as separate keys:
  "spotlight-card": drilldownData["spotlight-card"]?.map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, options, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),

  "spotlight-page": drilldownData["spotlight-page"]?.map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, options, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),

  
  highlight:drilldownData["highlight"]?.map(
    ({ fieldName, placeholder, name, formType, validation, className, loadOptions, options, usedFileType }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),


  // highlight: drilldownData["highlight"]?.map(
  //   ({ fieldName, placeholder, name, formType, validation, className, loadOptions, options, usedFileType }: ModuleFields) => ({
  //     name: name,
  //     type: formType,
  //     label: fieldName,
  //     placeholder: placeholder,
  //     validation: validation,
  //     className: className,
  //     options: options,
  //     loadOptions: loadOptions,
  //     usedFileType: usedFileType,
  //   })
  // ),

 youtube: drilldownData["youtube"]?.map(
  ({
    fieldName,
    placeholder,
    name,
    formType,
    validation,
    className,
    loadOptions,
    options,
    usedFileType,
    note
  }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    options: options,
    loadOptions: loadOptions,
    usedFileType: usedFileType,
    note
  })
),


 travellerEssentialsOverview: drilldownData["travellerEssentialsOverview"]?.map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
    })
  ),
  travellerEssentialsList: drilldownData["travellerEssentialsList"]?.map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
      note
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      usedFileType: usedFileType,
      note
    })
  ),
usefulTipsPageList: drilldownData["usefulTipsPageList"]?.map(
  ({
    fieldName,
    placeholder,
    name,
    formType,
    validation,
    className,
    loadOptions,
    options,
    usedFileType,
    note,
    uploadTrigger
  }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    options: options,
    loadOptions: loadOptions,
    usedFileType: usedFileType,
    note,
    uploadTrigger
  })
),
usefulTipsPageContent: drilldownData["usefulTipsPageContent"]?.map(
  ({
    fieldName,
    placeholder,
    name,
    formType,
    validation,
    className,
    loadOptions,
    options,
    usedFileType,
    note,
    uploadTrigger
  }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    options: options,
    loadOptions: loadOptions,
    usedFileType: usedFileType,
    note,
    uploadTrigger
  })
),
};